<template>
  <div>
    <TableFilters
      :filters="['supplier', 'dateRange', 'warehouse', 'total']"
      v-model="filter"
      :columns="columns"
      @updateColumnsTable="updateColumnsTable"
      :export="[`purchaseexport`]"
    ></TableFilters>

    <v-row class="py-0 my-0">
      <v-col cols="12" md="12" lg="7" class="pa-5">
        <v-btn-toggle v-model="toggle_exclusive">
          <v-btn @click="viewpdfFile()"> View Report </v-btn>
          <v-btn @click="exportPDF()"> Generate PDF </v-btn>
          <v-btn @click="exceldownload()"> Generate CSV </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <v-card class="lighten-12 mt-2" v-show="false">
      <v-container fluid class="light gray lighten-12">
        <v-row>
          <v-card-text class="pa-0">
            <v-data-table
              :items-per-page="1000"
              :fixed-header="true"
              :headers="headers"
              :items="PurchaseList"
              class="row-pointer"
              id="indextable5"
            >
              <template v-slot:no-data>
                <div class="mt-16 container justify-center item-center">
                  <noData name="Purchase" />
                </div>
              </template>
              <template v-slot:item.reference_number="{ item }">
                <CopyTableCell :text="item.reference_number"></CopyTableCell>
              </template>
              <!-- Status -->
              <template v-slot:item.is_active="{ item }">
                <v-chip
                  :x-small="true"
                  class="ma-2"
                  label
                  text-color="white"
                  :color="getStatusColor(item.is_active)"
                  dark
                  >{{ item.is_active ? 'Active' : 'Archived' }}</v-chip
                >
              </template>
              <template v-slot:item.date="{ item }">{{
                item.date | formatDate
              }}</template>

              <template v-slot:item.paid_amount="{ item }">
                <strong>{{
                  item.paid_amount | formatCurrency
                }}</strong></template
              >
              <template v-slot:item.discount_amount="{ item }"
                ><strong>{{
                  item.discount_amount | formatCurrency
                }}</strong></template
              >

              <template v-slot:item.total_amount="{ item }"
                ><strong>{{
                  item.total_amount | formatCurrency
                }}</strong></template
              >
              <template
                v-slot:item.supplier="{ item }"
                v-slot="{ errors }"
                name="Quantity"
                rules="numeric"
                >{{ item.supplier.name }}</template
              >
              <template v-slot:item.wareHouse="{ item }" v-slot="{ errors }">
                {{
                  WarehouseView == 'name'
                    ? item.wareHouse.name
                    : item.wareHouse.sortform
                }}</template
              >
              <template
                slot="body.append"
                v-if="PurchaseList && PurchaseList.length > 0"
              >
                <tr class="black--text">
                  <th class="title"></th>
                  <th class="title"></th>
                  <th class="title"></th>
                  <th class="title"></th>
                  <th>
                    <h3 class="justify-content-end pl-2">
                      {{ total | formatCurrency }}
                    </h3>
                  </th>
                  <th>
                    <h3 class="justify-content-end pl-2">
                      {{ discount | formatCurrency }}
                    </h3>
                  </th>

                  <th>
                    <h3 class="justify-content-end">
                      {{ paid | formatCurrency }}
                    </h3>
                  </th>
                  <th class="title"></th>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>
<script>
import TableFilters from '@/components/base/TableFilters';
import noData from '@/components/shared/noItem';
import jsPDF from 'jspdf';

import autoTable from 'jspdf-autotable';
import XLSX from 'xlsx';
import { DateTime } from '@grapecity/wijmo';
import moment from 'moment';
import { mapState } from 'vuex';

import _ from 'lodash';
export default {
  data: () => ({
    messages: [],
    hide: '',
    status: [
      { text: 'Active', value: 'active' },
      { text: 'Archived', value: 'archived' },
    ],

    columns: [
      {
        text: 'No',
        value: 'no',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.no,
      },
      {
        text: 'Date',
        value: 'date',
        show: true,
        disabled: false,
        width: '16.5%',
        render: (item) => moment(item.date).format('YYYY-MM-DD'),
      },
      {
        text: 'Reference No',
        value: 'reference_number',
        show: true,
        disabled: false,
        width: '16.5%',
        render: (item) => item?.reference_number,
      },
      {
        text: 'Supplier',
        value: 'supplier',
        show: true,
        disabled: false,
        width: '15%',
        render: (item) => item?.supplier.name,
      },
      {
        text: 'Total',
        value: 'total_amount',
        show: true,
        disabled: false,
        width: '12%',
        align: 'right',
        render: (item) => item?.total_amount,
      },
      {
        text: 'Discount',
        value: 'discount_amount',
        show: true,
        disabled: false,
        width: '12%',
        align: 'right',
        render: (item) => item?.discount_amount,
      },
      {
        text: 'Paid',
        value: 'paid_amount',
        show: true,
        disabled: false,
        width: '12%',
        align: 'right',
        render: (item) => item?.paid_amount,
      },
      {
        text: 'Warehouse',
        value: 'wareHouse',
        show: true,
        disabled: false,
        width: '16.5%',
        align: 'center',
        render: (item) => item?.wareHouse.name,
      },
      {
        text: 'Status',
        value: 'status',
        show: true,
        disabled: false,
        width: '16.5%',
        align: 'center',
        render: (item) => item?.status,
      },
    ],
    PurchaseList: [],
    filter: {
      invoice_status: '',
      start: '',
      end: '',
      amount: '',
      supplier: '',
      search: '',
    },
    menu: false,
    total: 0,
    paid: 0,
  }),
  components: {
    TableFilters,
    noData,
  },
  computed: {
    ...mapState(['WarehouseView']),
    ...mapState(['filterDatas']),

    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  created() {
    this.$store.commit('UPDATE_PDF_VISIBLE', false);
    this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
  },
  methods: {
    updateColumnsTable() {
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);
      setTimeout(() => {
        this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
      }, 100);
    },
    generateReport(callBack = () => {}) {
      this.$store.commit('UPDATE_PDF_VISIBLE', true);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);

      var filter = this.filter;
      this.$store
        .dispatch('report/getPurchaseReports', filter)
        .then((res) => {
          this.PurchaseList = res.data.data;
          this.total = this.sumField(this.PurchaseList, 'total_amount');
          this.discount = this.sumField(this.PurchaseList, 'discount_amount');
          this.paid = this.sumField(this.PurchaseList, 'paid_amount');
          let i = 1;
          this.PurchaseList.map((p) => {
            p.no = i;
            i++;
          });
          var purchaseAmount = {
            total: this.total,
            discount: this.discount,
            paid: this.paid,
          };
          setTimeout(() => {
            // Update Pdf To List
            this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
            // Update Pdf To List Datas
            this.$store.commit('UPDATE_PDF_DATAS', this.PurchaseList);
            // Update Pdf To List_Title
            this.$store.commit('UPDATE_PDF_TITLE', 'Purchases');
            this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
            this.$store.commit('UPDATE_PURCHASE_TOTAL', purchaseAmount);

            callBack();
          }, 100);
        })
        .catch((err) => {
          this.isLoading = false;
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
          this.$store.commit('UPDATE_PDF_VISIBLE', false);

          this.messages = err.data.title;
        });
    },
    async viewpdfFile() {
      await this.generateReport();
      setTimeout(() => {
        if (this.PurchaseList.length > 0) {
          this.$store.commit('UPDATE_PDF_VISIBLE', true);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
        }
      }, 1000);
    },

    sumField(array, filed) {
      let value = 0;
      array.forEach((element) => {
        value += element[filed];
      });
      return value;
    },
    //Product Details Export Pdf
    async exportPDF() {
      const printPdf = () => {
        let Data = _.cloneDeep(this.PurchaseList);
        for (let x = 0; x < Data.length; x++) {
          Data[x].date = moment(Data[x].date, 'YYYY-MM-DD').format(
            'DD/MM/YYYY',
          );
          Data[x].supplier = Data[x].supplier.name;
          Data[x].wareHouse = Data[x].wareHouse.name;
          Data[x].status = Data[x].is_active ? 'Active' : 'Archived';
        }
        var rows = Data;
        var doc = jsPDF({
          orientation: 'landscape',
        });
        doc.setFontSize(13);
        // doc.setFontType("bold");
        doc.setTextColor(26, 26, 26);
        doc.setFont('helvetica', 'normal');
        doc.text('Purchase Report', 15, 6);

        doc.setFontSize(8);
        doc.text(
          247,
          6,
          `Generated Date and Time  -  ${moment(today).format(
            'DD/MM/YYYY hh:mm:ss A',
          )}`,
          'center',
        );

        doc.text(219, 11, `Total Amount :      `);
        doc.text(
          281,
          11,
          ` ${this.total.toLocaleString('en-US', {
            style: 'currency',
            currency: 'LKR',
          })}`,
          'right',
        );
        doc.text(219, 16, `Discount Amount :      `);
        doc.text(
          281,
          16,
          ` ${this.discount.toLocaleString('en-US', {
            style: 'currency',
            currency: 'LKR',
          })}`,
          'right',
        );
        doc.text(219, 21, `Paid Amount :      `);
        doc.text(
          281,
          21,
          ` ${this.paid.toLocaleString('en-US', {
            style: 'currency',
            currency: 'LKR',
          })}`,
          'right',
        );
        const conditions = [
          { key: 'amount', label: 'Total greater than' },
          { key: 'supplierquery', label: 'Supplier' },
          { key: 'warehousequery', label: 'Warehouse' },
        ];

        // Function to get text based on filter data
        const getText = (key, label, value) => {
          return value ? `${label} - ${value}` : '';
        };

        // Iterate over conditions and build the text
        let height = conditions.reduce((acc, condition) => {
          const value = this.filterDatas[condition.key];
          const text = getText(condition.key, condition.label, value);

          if (text) {
            doc.text(text, 15, acc);
            return acc + 5; // Increment
          }

          return acc;
        }, 12); // Initial offset

        // Add Date Range if both start and end are available
        if (this.filterDatas.start && this.filterDatas.end) {
          const dateRangeText = `Date Range - ${this.filterDatas.start} - ${this.filterDatas.end}`;
          doc.text(dateRangeText, 15, height);
          height += 5; // Increment offset
        }

        // Set a default height if no conditions matched
        height = height || 20;

        doc.autoTable(
          this.headers.map((h) => {
            return { title: h.text, dataKey: h.value };
          }),
          rows,
          {
            didParseCell: function (data) {
              if (data.column.dataKey === 'addsress') {
                data.cell.text = data.cell.raw.country;
              }
            },
            startY: height,
          },
        );
        const today = new DateTime();
        doc.save(`${moment(today).format('DD-MM-YYYY')}-Purchase.pdf`);
      };
      this.generateReport(printPdf);
    },

    //Product Details Export Excel
    async exceldownload() {
      const printExcel = () => {
        var data = document.getElementById('indextable5');
        const today = new DateTime();
        const headData = XLSX.utils.table_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          wb,
          headData,
          moment(today).format('DD-MM-YYYY'),
        );
        XLSX.writeFile(
          wb,
          `${moment(today).format('DD-MM-YYYY')}-Purchase.xlsx`,
        );
      };
      this.generateReport(printExcel);
    },
  },
  watch: {
    filter(value) {
      this.$store.commit('UPDATE_PDF_DATAS', null);
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
    },
  },
};
</script>
